module.exports = __webpack_public_path__ + "static/golf-club-df7b480e6ff881ecc2e09edb33ac3008.jpg";